import axiosIns from "@/api/axios";
import querystring from "query-string";

export const GET_DATA_LIST = (params) => {
    return axiosIns.get(`/fund-center?${params}`);
};

export const CREATE_DATA = (body) => {
    return axiosIns.post('/fund-center', body);
};

export const DELETE_DATA = (id) => {
    return axiosIns.delete(`/fund-center/${id}`);
};

export const UPDATE_DATA = (body) => {
    return axiosIns.put(`/fund-center/${body.id}`, body.body);
};